<script setup>
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

onMounted(() => {
  const token = route.query.token
  
  if (token) {
    localStorage.setItem('steam_token', token)
    // Полное обновление страницы чтобы все компоненты получили данные пользователя
    window.location.href = '/'
  } else {
    router.push('/login-failed')
  }
})
</script>

<template>
  <div class="callback-page">
    <div class="loading-spinner"></div>
    <p>Logging in...</p>
  </div>
</template>

<style scoped>
.callback-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: #fff;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #222;
  border-top-color: #00d4ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
